import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="comment">
                1.&nbsp;<span className="material-symbols-outlined">tag</span>&nbsp;{translate('comment')}
            </Typography>
            <p><strong>{translate('comment')}</strong> is used to annotate the meaning of the script and make it easier to read.</p>

            <Typography variant="h5" gutterBottom id="setvariable">
                2.&nbsp;<span className="material-symbols-outlined">save</span>&nbsp;{translate('setvariable')}
            </Typography>
            <p><strong>{translate('setvariable')}</strong> is used to contain data.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>This is where the output of this action is stored and can be used in other actions.</td>
                                <td>$variableName_1</td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Is the value to store.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>For example, create a variable with <strong>{translate('outputkey')}</strong> <strong>$todayIs</strong> to store the value <i>Today is</i>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$todayIs</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div>Today is</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Today is</div>
                        </div>
                    </div>
                    <p>We can specify calculations by combining predefined functions and <strong>Output keys</strong>.</p>
                    <p>Create another variable with <strong>the Output key </strong> <strong>$result</strong> to store the value of <strong>$todayIs</strong> combined with a function that retrieves today's value.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$result</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>$todayIs + " " + GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span></div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>{"Today is " + FormatDate(new Date(), "yyyy-MM-dd")}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);